<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <div class="rappider-component navigation-bar-2">
    <!-- Component: Navigation Bar 2 -->
    <rappider-navigation-bar
      [menu]="navigationBar_2.menu"
      [isMenuVisible]="navigationBar_2.isMenuVisible"
      [brandRouteUrl]="navigationBar_2.brandRouteUrl"
      [brandImage]="navigationBar_2.brandImage"
      [brandText]="navigationBar_2.brandText"
      [isBrandVisible]="navigationBar_2.isBrandVisible"
      [buttons]="navigationBar_2.buttons"
      [dropdowns]="navigationBar_2.dropdowns"
      [togglerIcon]="navigationBar_2.togglerIcon"
      [isSearchable]="navigationBar_2.isSearchable"
      [searchArea]="navigationBar_2.searchArea"
      [cart]="navigationBar_2.cart"
      [drawer]="navigationBar_2.drawer"
      [isCartVisible]="navigationBar_2.isCartVisible"
      [responsiveMenuMode]="navigationBar_2.responsiveMenuMode"
    >
    </rappider-navigation-bar>
  </div>

  <!-- Container: Container 1 -->
  <div class="rappider-container container-1 col-12">
    <!-- Container: Container 2 -->
    <div class="rappider-container container-2 col-8">
      <div>
        <router-outlet></router-outlet>
      </div>
    </div>

    <!-- Container: Container 3 -->
    <div class="rappider-container container-3 col-4">
      <div class="rappider-component menu-3">
        <!-- Component: Menu 3 -->
        <rappider-menu
          [config]="menu_3.config"
          [isCollapsed]="menu_3.isCollapsed"
          [paddingValue]="menu_3.paddingValue"
          [menuPlacement]="menu_3.menuPlacement"
          [isDisabled]="menu_3.isDisabled"
          [showLabels]="menu_3.showLabels"
          [activeItem]="menu_3.activeItem"
          [currentSubmenuOnly]="menu_3.currentSubmenuOnly"
        >
        </rappider-menu>
      </div>
    </div>
  </div>

  <!-- Container: Container 4 -->
  <div class="rappider-container container-4 col-12">
    <!-- Container: Container 5 -->
    <div class="rappider-container container-5 col-4">
      <div class="rappider-component image-4">
        <!-- Component: Image 4 -->
        <rappider-image
          [source]="image_4.source"
          [alternateText]="image_4.alternateText"
          [placeholder]="image_4.placeholder"
          [disablePreview]="image_4.disablePreview"
          [borderSettings]="image_4.borderSettings"
          [shadowSettings]="image_4.shadowSettings"
          [paddingSettings]="image_4.paddingSettings"
          [marginSettings]="image_4.marginSettings"
          [customSizeSettings]="image_4.customSizeSettings"
        >
        </rappider-image>
      </div>

      <div class="rappider-component paragraph-5">
        <!-- Component: Paragraph 5 -->
        <rappider-paragraph
          [content]="paragraph_5.content"
          [colorSettings]="paragraph_5.colorSettings"
          [typography]="paragraph_5.typography"
        >
        </rappider-paragraph>
      </div>
    </div>

    <!-- Container: Container 6 -->
    <div class="rappider-container container-6 col-5">
      <!-- Container: Container 7 -->
      <div class="rappider-container container-7 col-12">
        <div class="rappider-component button-list-6">
          <!-- Component: Button List 6 -->
          <rappider-button-list
            [buttons]="buttonList_6.buttons"
            [direction]="buttonList_6.direction"
            [gap]="buttonList_6.gap"
          >
          </rappider-button-list>
        </div>
      </div>

      <!-- Container: Container 8 -->
      <div class="rappider-container container-8 col-12">
        <div class="rappider-component image-7">
          <!-- Component: Image 7 -->
          <rappider-image
            [source]="image_7.source"
            [alternateText]="image_7.alternateText"
            [placeholder]="image_7.placeholder"
            [disablePreview]="image_7.disablePreview"
            [borderSettings]="image_7.borderSettings"
            [shadowSettings]="image_7.shadowSettings"
            [paddingSettings]="image_7.paddingSettings"
            [marginSettings]="image_7.marginSettings"
            [customSizeSettings]="image_7.customSizeSettings"
          >
          </rappider-image>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
